import { render, staticRenderFns } from "./focusShop.vue?vue&type=template&id=106bbd2e&scoped=true"
import script from "./focusShop.vue?vue&type=script&lang=js"
export * from "./focusShop.vue?vue&type=script&lang=js"
import style0 from "./focusShop.vue?vue&type=style&index=0&id=106bbd2e&prod&lang=scss&scoped=true"
import style1 from "./focusShop.vue?vue&type=style&index=1&id=106bbd2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106bbd2e",
  null
  
)

export default component.exports